import { DeliveryItem } from "../../entities/delivery";
import { Pricing } from "../../entities/pricing";
import { CreateOneStrategy } from "../base/creation.strategy";

import { useDictStore } from "@/stores/dictStore";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useDistanceStore } from "@/modules/shipping/store/distance.store";

export class DeliverItemsCreationStrategy extends CreateOneStrategy {
    constructor(
        type: string
    ) {
        const minDeliveryItemPrice = 250;
        const dicts = useDictStore();
        const estimateStore = useNewEstimateStore();
        const distanceStore = useDistanceStore();

        const stateCode = estimateStore.estimate.shippingState;
        const stateInfo = dicts.findState(stateCode);

        const capitalize = (str: string) => {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }

        const miles = distanceStore.distance?.distance_miles || 0;
        const deliveryPricePerMile = stateInfo?.[`${type}_price`] || 0;
        const deliveryItemSum = deliveryPricePerMile * miles;
        const deliveryItemMinSum = deliveryItemSum > minDeliveryItemPrice ? deliveryItemSum : minDeliveryItemPrice;

        const deliveryItemConfig = {
            delivery_type: type,
            title: `${capitalize(type)} delivery`,
            qty: miles,
            price: new Pricing(
                deliveryPricePerMile,
                deliveryPricePerMile,
                deliveryPricePerMile,
            ),
            sum: new Pricing(
                deliveryItemMinSum,
                deliveryItemMinSum,
                deliveryItemMinSum,
            ),
        };

        super(deliveryItemConfig, DeliveryItem);
    }
}
